<template>
  <div class="card">
    <header class="header-card">
      <p>
        {{ $t('detailProduitPresse.formatProduit.title') }}
      </p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column is-3">
          <p class="has-text-default is-italic">
            {{ $t('detailProduitPresse.formatProduit.typeFormatPresse') }}
          </p>
          <p class="has-text-weight-bold">
            {{ getTypeFormatPresseLibelle(produit.typeFormatPresseId) }}
          </p>
        </div>
        <div class="column is-3">
          <p class="has-text-default is-italic">
            {{ $t('detailProduitPresse.formatProduit.largeurPleinPapier') }}
          </p>
          <p class="has-text-weight-bold">
            {{ produit.largeurPleinPapier }}
          </p>
        </div>
        <div class="column is-3">
          <p class="has-text-default is-italic">
            {{ $t('detailProduitPresse.formatProduit.hauteurPleinPapier') }}
          </p>
          <p class="has-text-weight-bold">
            {{ produit.hauteurPleinPapier }}
          </p>
        </div>
        <div class="column is-3">
          <p class="has-text-default is-italic">
            {{ $t('detailProduitPresse.formatProduit.largeurFormatUtile') }}
          </p>
          <p class="has-text-weight-bold">
            {{ produit.largeurFormatUtile }}
          </p>
        </div>
        <div class="column is-3">
          <p class="has-text-default is-italic">
            {{ $t('detailProduitPresse.formatProduit.hauteurFormatUtile') }}
          </p>
          <p class="has-text-weight-bold">
            {{ produit.hauteurFormatUtile }}
          </p>
        </div>
        <div class="column is-3">
          <p class="has-text-default is-italic">
            {{ $t('detailProduitPresse.formatProduit.margeHaut') }}
          </p>
          <p class="has-text-weight-bold">
            {{ produit.margeHaut }}
          </p>
        </div>
        <div class="column is-3">
          <p class="has-text-default is-italic">
            {{ $t('detailProduitPresse.formatProduit.margeGauche') }}
          </p>
          <p class="has-text-weight-bold">
            {{ produit.margeGauche }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAll } from '@/api/presse/typeFormatPresse/';
import messageErreur from '@/services/general/messageErreur';

export default {
  name: 'formatProduitPresse',
  props: {
    produit: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      typesFormatPresse: [],
    };
  },
  methods: {
    getTypeFormatPresseLibelle(id) {
      const typeFormatPresse = this.typesFormatPresse.find((type) => {
        return type.id === id;
      });
      return typeFormatPresse ? typeFormatPresse.code + ' ' + typeFormatPresse.libelle : '';
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.typesFormatPresse = (await getAll({ query: {} }))
        .data.result.items;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
